export default __webpack_public_path__ + "static/poster-9958dff60a2e367532b3ebbc4ee08644.png";